import { TRPCClientError } from "@trpc/client";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { trpc } from "@/lib/trpc";

export const Route = createFileRoute("/_authenticated")({
  loader: async ({ context, location }) => {
    try {
      return await context.queryClient.ensureQueryData(trpc.organization.viewer.queryOptions());
    } catch (error) {
      if (error instanceof TRPCClientError && error.data?.code === "UNAUTHORIZED") {
        // A deep link survives an expired session; a bare `/` resolves to
        // Last place after login, so it needs no `next`.
        const next = `${location.pathname}${location.searchStr}`;
        throw redirect({ to: "/login", search: next === "/" ? {} : { next } });
      }
      throw error;
    }
  },
  component: DashboardLayout,
});

function DashboardLayout() {
  return <Outlet />;
}
